import { render, staticRenderFns } from "./groupstageList.vue?vue&type=template&id=dd5617be&scoped=true&"
import script from "./groupstageList.vue?vue&type=script&lang=js&"
export * from "./groupstageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5617be",
  null
  
)

export default component.exports